import styled from 'styled-components';
import { motion } from 'framer-motion';
import fonts from '../../design-system/fonts';
import { colors } from '../../design-system/colors';

export const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${colors.porcelain};
`;

export const Container = styled(motion.div)`
  width: 100%;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const MainContent = styled.main`
  flex: 1;
  padding-top: 100px;
  @media (max-width: 768px) {
    padding-top: 60px;
  }
`;

export const IntroSection = styled.section`
  padding: 40px 0 40px;
  background: ${colors.porcelain};

  @media (max-width: 768px) {
    padding: 40px 0 40px;
  }
`;

export const IntroGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 20px;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

export const IntroHeading = styled(motion.h1)`
  font-size: 64px;
  font-weight: 800;
  line-height: 1.1;
  color: ${colors.sapphire};
  margin: 0;
  letter-spacing: -0.03em;

  @media (max-width: 768px) {
    font-size: 42px;
  }
`;

export const IntroTextContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const IntroText = styled.p`
  font-size: 19px;
  line-height: 1.7;
  color: ${colors.deepCharcoal};
  opacity: 0.85;
  font-family: ${fonts.body};
  margin: 0;

  @media (max-width: 768px) {
    font-size: 17px;
  }
`;

export const MDSection = styled.section`
  padding: 80px 0 60px;
  background: white;
  position: relative;

  @media (max-width: 768px) {
    padding: 60px 0 60px;
  }
`;

export const MDContainer = styled.div`
  margin: 0 auto;
`;

export const MDLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 46px;
`;

export const MDHeader = styled.div`
  text-align: left;
  max-width: 800px;
`;

export const MDTitle = styled(motion.h2)`
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3em;
  color: ${colors.goldenBronze};
  margin-bottom: 16px;
`;

export const MDHeading = styled(motion.h3)`
  font-size: 48px;
  font-weight: 800;
  color: ${colors.deepCharcoal};
  line-height: 1.1;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

export const MDMainContent = styled.div`
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 80px;
  align-items: start;

  @media (max-width: 1200px) {
    gap: 40px;
    grid-template-columns: 300px 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 48px;
  }
`;

export const MDImageColumn = styled.div`
  @media (max-width: 768px) {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }
`;

export const MDImageWrapper = styled(motion.div)`
  position: relative;
  width: 100%;
`;

export const MDImage = styled.img`
  width: 100%;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  border-radius: 8px;
  position: relative;
  z-index: 1;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.12);
`;

export const MDTextContent = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const MDParagraph = styled.p`
  font-size: 17px;
  line-height: 1.8;
  color: ${colors.deepCharcoal};
  opacity: 0.8;
  font-family: ${fonts.body};
  margin: 0;

  strong {
    color: ${colors.sapphire};
    opacity: 1;
    font-weight: 600;
  }
`;

export const MDQuote = styled(motion.div)`
  padding-top: 26px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  font-size: 28px;
  font-weight: 700;
  color: ${colors.sapphire};
  line-height: 1.3;
  font-family: ${fonts.headline};

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;
